// Carry Roll Reference ranges — optimal-range reference data (10.2).
import { ClubCategory } from '../engine/types';
export const REFERENCE_RANGES = [
    { category: ClubCategory.Driver, ballSpeedMsMin: 60, ballSpeedMsMax: 90, launchAngleDeg: [10, 16], spinRpm: [2000, 3200] },
    { category: ClubCategory.Wood, ballSpeedMsMin: 50, ballSpeedMsMax: 75, launchAngleDeg: [12, 18], spinRpm: [2500, 4000] },
    { category: ClubCategory.Hybrid, ballSpeedMsMin: 45, ballSpeedMsMax: 68, launchAngleDeg: [14, 20], spinRpm: [3000, 4500] },
    { category: ClubCategory.Iron, ballSpeedMsMin: 35, ballSpeedMsMax: 60, launchAngleDeg: [16, 28], spinRpm: [4000, 8000] },
    { category: ClubCategory.Wedge, ballSpeedMsMin: 25, ballSpeedMsMax: 45, launchAngleDeg: [24, 40], spinRpm: [6000, 11000] },
];
export function findReference(category, ballSpeedMs) {
    return (REFERENCE_RANGES.find((r) => r.category === category && ballSpeedMs >= r.ballSpeedMsMin && ballSpeedMs <= r.ballSpeedMsMax) ?? REFERENCE_RANGES.find((r) => r.category === category) ?? null);
}
//# sourceMappingURL=referenceRanges.js.map